import {
    Breakpoint,
    CandidateInterviewResult,
    MessageComposer,
    useRelodeAppUI,
    useRouter,
    SetInterviewSubmitStatus,
    CandidateInterviewType,
} from "@relode/core";
import * as React from "react";

import { ShareCandidateDialog } from "../../../../../shared/components/candidate";
import { useCandidateContext } from "../../../_infra/candidateProvider";
import { CandidateDetailsDesktop } from "./candidateDetailsDesktop";
import { CandidateDetailsMobile } from "./candidateDetailsMobile";

export const CandidateDetails = () => {
    const {
        state: {
            data: {
                candidate,
                currentJobId,
                currentLeadId,
                candidateShareInfo,
            },
        },
        actions,
    } = useCandidateContext();

    const { location } = useRouter();
    const { ui: appUIState } = useRelodeAppUI();

    const [backUrl, setBackUrl] = React.useState("");
    const [isShareCandidateOpen, setIsShareCandidateOpen] = React.useState(
        false
    );

    const [messageComposerOpen, setMessageComposerOpen] = React.useState(false);

    React.useEffect(() => {
        setBackUrl(location.state ? location.state["backUrl"] : undefined);
        appUIState.actions.setPageTitle(candidate.highlights.fullName);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleShareCandidate = async () => {
        if (!candidate) return;

        await actions.loadCandidateShare(
            candidate.job.jobId,
            candidate.highlights.leadId
        );

        setIsShareCandidateOpen(true);
    };

    const addOrUpdateFeedback = async (comment: string, vote: boolean) => {
        if (!!candidate.feedbackDetails.clientFeedback) {
            await actions.updateFeedback(
                currentJobId,
                currentLeadId,
                vote,
                comment
            );
        } else {
            await actions.addFeedback(
                currentJobId,
                currentLeadId,
                vote,
                comment
            );
        }
    };

    const handleSubmitInterview = async (
        interviewResult: CandidateInterviewResult,
        setInterviewSubmitStatus: SetInterviewSubmitStatus
    ) => {
        if (!!interviewResult.candidateInterviewId) {
            return await actions.editInterview(
                currentLeadId,
                currentJobId,
                interviewResult,
                candidate.candidateConcurrencyToken,
                setInterviewSubmitStatus
            );
        } else {
            return await actions.addInterview(
                currentLeadId,
                currentJobId,
                interviewResult,
                candidate.candidateConcurrencyToken,
                setInterviewSubmitStatus
            );
        }
    };

    const handleSendManualInterviewNotification = async (
        interviewId: number,
        subject: string,
        recipientUserIds: number[],
    ) => {
        const success = await actions.sendInterviewNotification(
            currentLeadId,
            currentJobId,
            interviewId,
            candidate.candidateConcurrencyToken,
            subject,
            recipientUserIds
        );
        return success;
    };

    return (
        <>
            <Breakpoint mobile>
                <CandidateDetailsMobile
                    backUrl={backUrl}
                    addOrUpdateFeedback={addOrUpdateFeedback}
                    toggleShareCandidate={handleShareCandidate}
                    toggleMessageComposer={setMessageComposerOpen}
                    handleSubmitInterview={handleSubmitInterview}
                    handleSendManualInterviewNotification={
                        handleSendManualInterviewNotification
                    }
                />
            </Breakpoint>
            <Breakpoint desktop>
                <CandidateDetailsDesktop
                    backUrl={backUrl}
                    addOrUpdateFeedback={addOrUpdateFeedback}
                    toggleShareCandidate={handleShareCandidate}
                    toggleMessageComposer={setMessageComposerOpen}
                    handleSubmitInterview={handleSubmitInterview}
                    handleSendManualInterviewNotification={
                        handleSendManualInterviewNotification
                    }
                />
            </Breakpoint>
            {isShareCandidateOpen ? (
                <ShareCandidateDialog
                    onCancel={() => setIsShareCandidateOpen(false)}
                    shareInfo={{
                        name: candidate.highlights.fullName,
                        emailUrl: candidateShareInfo.emailUrl,
                        shortenedUrl: candidateShareInfo.shortenedUrl,
                    }}
                />
            ) : null}
            {messageComposerOpen ? (
                <MessageComposer
                    open={messageComposerOpen}
                    onClose={() => setMessageComposerOpen(false)}
                    jobName={candidate.job.jobName}
                    leadName={candidate.highlights.fullName}
                    leadId={candidate.highlights.leadId}
                    jobId={candidate.job.jobId}
                />
            ) : null}
        </>
    );
};
